import { render, staticRenderFns } from "./CvTable.vue?vue&type=template&id=093fca88&"
import script from "./CvTable.vue?vue&type=script&lang=js&"
export * from "./CvTable.vue?vue&type=script&lang=js&"
import style0 from "./CvTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports